<i18n>
{
	"no": {
		"cancelLabel" : "Lukk",
		"header" : "Inngående EDI detaljer",
		"details": "Detaljer",
		"ediMessage" : "EDI melding",
		"orderDetails" : "Importert ordre / Feil",
		"id" : "TransmissionId: {id}",
		"importErrors" : "Denne EDI meldingen har feil / bug ved import",
		"sendingErrors" : "Denne EDI meldingen har feil ved import.",
		"success" : "Denne EDI meldingen er importert uten feil",
		"downloadEdiFIle": "Last ned EDI melding",
		"reImportMessage": "Re-importer",
		"reimportWarning": "Denne meldingen er allerede importert. Ønsker du virkelig å re-importere EDI meldingen? \n Re-import av meldingen kan forårsake at den overskriver oppdraget om det ikke er fakturert",
		"reimportInfo": "Denne meldingen er ikke importert på grunn av en importeringsfeil. Ønsker du å forsøke å importere denne meldingen?",
		"currentlyReimportingMesesage" :"Re-importerer...."
	},
	"en": {
		"details": "Details",
		"cancelLabel" : "Close",
		"header" : "Inspekasjon av inngående EDI forsendelse",
		"ediMessage" : "EDI message",
		"orderDetails" : "Imported order / Error",
		"id" : "TransmissionId: {id}",
		"importErrors" : "This EDI message has import errors to it",
		"sendingErrors" : "This EDI message has sending errors and has not been sent",
		"notSent" : "This EDI message has been created successfully but not been sent yet",
		"success" : "This EDI message has been imported successfully",
		"downloadEdiFIle": "Download EDI message",
		"reImportMessage": "Re-import",
		"reimportWarning": "This message is already imported. Do you really wish to import this EDI message again?. \n It may overwrite the existing order for this message unless order is invoiced",
		"reimportInfo": "This message has not yet been imported because of an error. Do you wish to attempt to import this EDI message?",
		"currentlyReimportingMesesage" :"Re-importing...."
	}

}
</i18n>
<template>

	<t-dialog
		:isShown="isShown"
		:cancelLabel="$t('cancelLabel')"
		:icon="getCorrectIcon.icon"
		:iconType="'bp'"
		:title="getCorrectTitle"
		:iconColor="getCorrectIcon.color"
		@close="$emit('close')"
		@cancel="$emit('close')"
	>

		<div class="inspect-dialog">
			<div class="inspect-nav">
				<h4>{{$t('header')}}</h4>
				<t-tab-list :items="tabs" :selected.sync="selectedTab" sidebar>
					<template v-slot="slotProps">
						<t-tab :value="slotProps.item" :selected="slotProps.isSelected" :sidebar="slotProps.sidebar">
							{{$t(slotProps.item.key)}}
						</t-tab>
					</template>
				</t-tab-list>
			</div>
			<t-pane class="settings-content">
				<component :is="selectedTab.id" :ref="selectedTab.ref" :ordersAndErrors="ordersAndErrors" />
			</t-pane>
		</div>
		<template #footer>
			<div style="width: 100%; display: flex; justify-content: space-between">
				<div class="flex-container">
					<t-button
						class="flex-item"
						:value="$t('downloadEdiFIle')"
						appearance="primary"
						type="bp"
						iconBefore="arrow-down"
						tabindex="-1"
						@click="downloadEdiFile"
					/>
					<t-button
						class="flex-item"
						:value="currentlyReimporting ? $t('currentlyReimportingMesesage') :$t('reImportMessage')"
						appearance="primary"
						intent="danger"
						type="bp"
						iconBefore="refresh"
						tabindex="-1"
						width="12em"
						:busy="currentlyReimporting"
						@click="showConfirmDialog = true"
					/>
				</div>
			</div>
		</template>

		<ConfirmDialog
			:description="getTransmissionDetails.error ? $t('reimportInfo') : $t('reimportWarning')"
			:title="$t('reImportMessage')"
			:isShown="showConfirmDialog"
			@yes="reimport"
			@close="showConfirmDialog = false"
		/>
	</t-dialog>

</template>

<script>

import Details from './Details.vue';
import EdiMessage from './EdiMessage.vue';
import OrderDetails from '../common/OrderDetails.vue';
import ConfirmDialog from '../common/ConfirmDialog.vue';
import { mapGetters, mapActions } from './store/inbound.store';
import { edi } from '@/requests';
import { baseUrl } from '@/core';

export default {
	components: { Details, EdiMessage, OrderDetails, ConfirmDialog },
	props: { isShown: Boolean },
	data() {
		return {
			tabs: [{ id:'Details', key: 'details', ref: 'details' }, { id:'EdiMessage', key: 'ediMessage', ref: 'ediMessage' }, { id:'OrderDetails', key: 'orderDetails', ref: 'orderDetails' }],
			selectedTab: { id:'Details', key: 'details', ref: 'details' },
			showConfirmDialog: false,
			currentlyReimporting: false,
		};
	},

	computed: {
		...mapGetters(['getTransmissionDetails']),
		getCorrectTitle() {
			if (this.getTransmissionDetails.error)
				return this.$t('importErrors');
			return 	this.$t('success');
		},
		ordersAndErrors() {
			let orders = this.getTransmissionDetails.orders || [];
			let orderIds = orders.map(this.mapOrderIds);
			return {
				orderIds: orderIds,
				originalData: this.getTransmissionDetails.orders,
				error: this.getTransmissionDetails.error
			};
		},
		getCorrectIcon() {
			if (this.getTransmissionDetails.error)
				 return { icon: 'cross', color: 'red' };
			return { icon: 'tick', color: 'green' };
		},
	},
	methods: {
		...mapActions(['reimportTransmission']),
		mapOrderIds(data) {
			if (this.getTransmissionDetails.setup.messageType === 1)
				return data.id;
			else if (this.getTransmissionDetails.setup.messageType === 5)
				return data.mainOrderId;
			else
				return data.id;
		},
		downloadEdiFile() {
			let url = edi.downloadInboundEdiFile(this.getTransmissionDetails.id);
			let fullyQualifiedUrl = baseUrl() + url;
			window.open(fullyQualifiedUrl);
		},

		reimport() {
			this.currentlyReimporting = true;
			this.reimportTransmission({ transmissionId: this.getTransmissionDetails.id,
				callback: () => {
					this.currentlyReimporting = false;
				} });
			this.showConfirmDialog = false;
		}
	}
};

</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';

.inspect-dialog{
	height:560px;
	display: grid;
	grid-template-columns: 240px 1100px;
}

.flex-container{
	display:flex;
	width:100%;
}

.flex-item{
	margin: 5px;
}

.inspect-nav{
	border-right: 2 px solid get-color($border, 'default');
}

</style>